export default "__VITE_ASSET__PY6wTA01__"